import { makeRequest } from 'utils/requestLogger';

export default (id, courses_ids) =>
    makeRequest('put', `/api/schools/${id}/teacher-courses`, courses_ids);



// WEBPACK FOOTER //
// ./src/app/services/courses/syncCourses.js